const defaultOffset = 250

export function scrollToElementByIdWithOffset(elementId, offset = defaultOffset) {
  const element = document.getElementById(elementId)

  if (element) {
    const elementRect = element.getBoundingClientRect()
    const absoluteElementTop = elementRect.top + window.scrollY
    const targetPosition = absoluteElementTop - offset

    window.scroll({
      top: targetPosition,
      behavior: 'smooth'
    })
  }
}
